import React, { Component } from "react";
import PropTypes from "prop-types";
import ChatIcon from "./ChatIcon";

class EndingView extends Component {
  render() {
    return /*#__PURE__*/React.createElement("div", {
      id: "chat-view",
      className: "ending-view"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ChatIcon, {
      className: "large"
    }), /*#__PURE__*/React.createElement("span", {
      className: "are-you-sure"
    }, "Are you sure you want to end this chat?"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
      onClick: this.props.onEndChatClick,
      className: "end-chat"
    }, "Yes, end the chat"))), /*#__PURE__*/React.createElement("div", {
      className: "return-to-chat"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
      className: "flat-white",
      onClick: this.props.onReturnToChatClick
    }, "Return to chat"))));
  }

}

EndingView.propTypes = {
  onEndChatClick: PropTypes.func,
  onReturnToChatClick: PropTypes.func
};
export default EndingView;